module.exports = __webpack_public_path__ + "img/image8.ef7523fd.png";